// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d42df406","239":"e556d3bc","455":"f46dee95"}[chunkId] + ".chunk.js";
};